document.addEventListener('DOMContentLoaded', () => {
  // Setup elements
  const navDialog = document.getElementById('navDialog');
  const openNavBtn = document.getElementById('openNavBtn');
  const closeNavBtn = document.getElementById('closeNavBtn');

  // Open cart handler
  const openNav = () => {
    navDialog.classList.remove('animate-dialog-open');
    if (typeof navDialog.showModal === 'function') {
      navDialog.showModal();
    } else {
      // Fallback for browsers that do not support dialog.showModal()
      navDialog.style.display = 'block';
    }

    // Animate the dialog after it's opened
    requestAnimationFrame(() => {
      navDialog.classList.add('animate-dialog-open');
    });
  };

  // Open when clicking the open button
  openNavBtn?.addEventListener('click', openNav);

  // Close when clicking the close button
  closeNavBtn?.addEventListener('click', () => {
    navDialog.close();
  });

  // Close when clicking outside of it
  navDialog?.addEventListener('click', (event) => {
    if (event.target === navDialog) {
      navDialog.close();
    }
  });
});
